import { Link, useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import classes from "./titleAndLogo.module.css";

export default function TitleAndLogo() {
  const navigate = useNavigate();
  const titleKlik = () => navigate("/");

  return (
    <>
      <Link to="/">
        <div className={classes.main} id="logoDiv">
          <img
            src="/img/pumi.png"
            className={classes.logo}
            onClick={titleKlik}
            aria-label="Etusivulle"
            alt="logo"
          />
          <Typography variant="h6" noWrap component="div" className={classes.title}>
            <div className="gradientTextDark">
              <b>betoni</b>.online
            </div>
          </Typography>
          <div className={classes.smallTitle}>
            <div className="gradientTextDark">
              <b>betoni</b>.online
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}
